import React from 'react';
import { Page } from '../page/page';
import { ContactUs } from '../contact-us/contact-us';
import { Teachers } from './teachers';
import { MissionStatementContainer } from './mission-statement-container';

export const AboutUsPage = ({ roles, classes }) => {
  return <Page sections={[ContactUs, MissionStatementContainer, Teachers]} />;
};
